module.exports = __webpack_public_path__ + "static/media/whatsappIcon.60b7ec86.svg";